import type { DiyanetVerse } from '@app-types/index'
import useSWR from 'swr'

/**
 * Fetches one verse's tefsir and fails on non-2xx responses, so a 404/500
 * reaches SWR as an error instead of being shown as an empty tefsir.
 */
const fetchAyahTefsir = async (url: string): Promise<DiyanetVerse> => {
  const response = await fetch(url)
  if (!response.ok) throw new Error(`Tefsir request failed with ${response.status}`)
  return response.json()
}

/**
 * Loads the Diyanet tefsir of a single ayah from `/api/tefsir/[surah]/[verse]`.
 * Nothing is requested until `enabled` is true (e.g. the tefsir section is opened),
 * and SWR caches the result so reopening the same ayah does not fetch again.
 */
export const useAyahTefsir = (surahId: number, verseNumber: number, enabled: boolean) => {
  const { data, error, isLoading } = useSWR(
    enabled ? `/api/tefsir/${surahId}/${verseNumber}` : null,
    fetchAyahTefsir,
    { revalidateOnFocus: false, shouldRetryOnError: false },
  )

  return { tefsir: data, hasError: Boolean(error), isLoading }
}
